import { z } from 'zod'

const text = z.string().nullish()

/** Who wrote a comment, as the server describes them: the name, the roles they hold and the company they belong to. */
export const conversationAuthorSchema = z.object({
  id: z.string(),
  name: text,
  /** Not always sent; when it is not, the person's record is asked for. */
  email: text,
  roles: z.array(z.string()).nullish(),
  accountId: text,
  accountName: text,
  accountType: text,
})
export type ConversationAuthorDto = z.infer<typeof conversationAuthorSchema>

/** One comment on a project. Comments are never edited or removed, so `updatedAt` is the same moment as `createdAt`. */
export const conversationMessageSchema = z.object({
  id: z.string(),
  message: z.string().nullish().transform((value) => value ?? ''),
  createdBy: conversationAuthorSchema.nullish(),
  createdAt: text,
  updatedAt: text,
})
export type ConversationMessageDto = z.infer<typeof conversationMessageSchema>

/** A page of comments. `totalMessages` counts all of them, on every page. */
export const conversationPageSchema = z.object({
  projectId: text,
  totalMessages: z.number().default(0),
  page: z.number().default(1),
  pageSize: z.number().default(0),
  messages: z.array(conversationMessageSchema).nullish().transform((items) => items ?? []),
})
export type ConversationPageDto = z.infer<typeof conversationPageSchema>

/** POST body: `createdBy` is the id of the person commenting. */
export interface PostCommentBody {
  createdBy: string
  message: string
}
